// 扫码流程共用定义（规范 docs/specs/singpass-corppass-scan.md）：页面状态、次数上限、卡住原因
export type ScanState =
  | "tab_missing"
  | "session_expired"
  | "auth_error"
  | "logged_in"
  | "awaiting_confirm"
  | "qr_expired"
  | "qr_active";

/** 同一认证会话内自动刷新上限 / 手动 + 自动合计上限；同一次运行内连续重新登录上限 */
/** autoRelogin：有人开着扫码弹框时，系统自动重新登录的上限（每次运行） */
export const SCAN_LIMITS = { autoRefresh: 3, refresh: 6, relogin: 3, autoRelogin: 10 } as const;

export const SCAN_AUTH_ERROR_PREFIX = "扫码认证被拒";
export const SCAN_RELOGIN_LIMIT_REASON = "多次重新登录未成功，需要人工检查";

/** 卡住原因是否属于「可点重新登录恢复」的扫码类卡住 */
export function isScanBlockReason(reason: string | null | undefined): boolean {
  return /分钟无人扫码/.test(reason ?? "") || (reason ?? "").startsWith(SCAN_AUTH_ERROR_PREFIX);
}
